export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6674.f39973eb.jpg";